import type { NoteSectionInput } from '@wodi/shared';

import { retryQueue } from './retry-queue.ts';

// A consultation note draft typed while offline (ADR 0018). The note panel already keeps
// the draft on this device and autosaves it while the workspace is open; the queue also
// sends the newest draft after the clinician has moved on, with an Idempotency-Key. Only
// the newest draft per consultation is kept. Signing is never queued.

export async function queueNoteDraft({
  consultationId,
  visitId,
  sections,
  templateId,
}: {
  consultationId: string;
  visitId: string;
  sections: NoteSectionInput[];
  templateId: string | null;
}): Promise<void> {
  await retryQueue
    .enqueue({
      kind: 'note-draft',
      target: consultationId,
      label: 'Consultation note draft',
      href: `/visits/${visitId}/consultation`,
      method: 'PUT',
      path: `/consultations/${consultationId}/note/draft`,
      body: { sections, templateId },
      clearDraftKey: null,
      refresh: [],
      sentTitle: null,
      urgent: false,
    })
    .catch(() => undefined);
}

/** The note reached Wodi another way (autosave or signing): nothing left to send. */
export async function noteDraftSent(consultationId: string): Promise<void> {
  await retryQueue.removeTarget('note-draft', consultationId);
}
